import { request, tokenHandler } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import {
  SensorDataSessionFilter,
  SensorDataSessionFilterFormatted,
  SensorDataSessionMarkerFilter,
  SensorDataSessionValuesFilter,
  SensorDataSessionProcessedValuesFilter,
} from "@shared/interfaces";

import {
  CreateSensorDataSessionMarkerDotDto,
  CreateSensorDataSessionMarkerDto,
  DeleteSensorDataSessionMarkerDotDto,
  DeleteSensorDataSessionMarkerDto,
} from "../interfaces";

export default {
  getSensorDataSessions: (payload: SensorDataSessionFilter) => {
    const { hospital, ...restParams } = payload;
    const params: SensorDataSessionFilterFormatted = {
      ...restParams,
      search: payload.search?.trim(),
    };

    if (hospital) {
      params.hospital_id = Number(hospital.value);
    }

    return request(METHODS.GET, API.SENSOR_DATA_SESSIONS.GET_SENSOR_DATA_SESSIONS)({ params });
  },
  getSensorDataSessionValues: (payload: SensorDataSessionValuesFilter & { id: number }) => {
    const { id, ...filter } = payload;
    return request(
      METHODS.GET,
      API.SENSOR_DATA_SESSIONS.GET_SENSOR_DATA_SESSION_VALUES(String(id)),
    )({ params: filter });
  },
  downloadSensorDataSessionValues: (id: number) => {
    return request(
      METHODS.GET,
      API.SENSOR_DATA_SESSIONS.DOWNLOAD_SENSOR_DATA_SESSION_VALUES(id),
    )({ params: { key: tokenHandler.get() } });
  },
  getSensorDataSessionProcessedValues: (payload: SensorDataSessionProcessedValuesFilter) => {
    const { id, ...filter } = payload;
    return request(
      METHODS.GET,
      API.SENSOR_DATA_SESSIONS.GET_SENSOR_DATA_SESSION_PROCESSED_VALUES(String(id)),
    )({ params: filter });
  },
  createSensorDataSession: (payload: FormData, onUploadProgress: (p: { loaded: number; total: number }) => void) =>
    request(METHODS.POST, API.SENSOR_DATA_SESSIONS.CREATE_SENSOR_DATA_SESSION)(payload, {
      onUploadProgress,
    }),
  getSensorDataSession: (payload: { id: number }) => {
    const { id } = payload;
    return request(METHODS.GET, API.SENSOR_DATA_SESSIONS.GET_SENSOR_DATA_SESSION(String(id)))();
  },
  deleteSensorDataSession: (payload: { id: number }) => {
    const { id } = payload;
    return request(METHODS.DELETE, API.SENSOR_DATA_SESSIONS.DELETE_SENSOR_DATA_SESSION(String(id)))();
  },
  updateSensor: (
    payload: { id: number; data: FormData },
    onUploadProgress: (p: { loaded: number; total: number }) => void,
  ) => {
    const { id, data } = payload;
    return request(METHODS.PUT, API.SENSOR_DATA_SESSIONS.UPDATE_SENSOR_DATA_SESSION(String(id)))(data, {
      onUploadProgress,
    });
  },
  createSensorDataSessionMarker: (payload: CreateSensorDataSessionMarkerDto) => {
    const { session_id, ...rest } = payload;
    return request(METHODS.POST, API.SENSOR_DATA_SESSIONS.CREATE_SENSOR_DATA_SESSION_MARKER(String(session_id)))(rest);
  },
  deleteSensorDataSessionMarker: (payload: DeleteSensorDataSessionMarkerDto) => {
    const { session_id, marker_id } = payload;
    return request(
      METHODS.DELETE,
      API.SENSOR_DATA_SESSIONS.DELETE_SENSOR_DATA_SESSION_MARKER(String(session_id), String(marker_id)),
    )();
  },
  getSensorDataSessionMarkers: (payload: SensorDataSessionMarkerFilter) => {
    const { session_id, ...filter } = payload;
    return request(
      METHODS.GET,
      API.SENSOR_DATA_SESSIONS.GET_SENSOR_DATA_SESSION_MARKERS(String(session_id)),
    )({ params: filter });
  },
  createSensorDataSessionMarkerDot: (payload: CreateSensorDataSessionMarkerDotDto) => {
    const { session_id, session_marker_id, ...rest } = payload;
    return request(
      METHODS.POST,
      API.SENSOR_DATA_SESSIONS.CREATE_SENSOR_DATA_SESSION_MARKER_DOT(String(session_id), String(session_marker_id)),
    )(rest);
  },
  deleteSensorDataSessionMarkerDot: (payload: DeleteSensorDataSessionMarkerDotDto) => {
    return request(
      METHODS.DELETE,
      API.SENSOR_DATA_SESSIONS.DELETE_SENSOR_DATA_SESSION_MARKER_DOT(
        String(payload.session_id),
        String(payload.session_marker_id),
        String(payload.dot_id),
      ),
    )();
  },
  getSensorDataSessionDots: (payload: { id: number; files: number[]; station: string }) => {
    return request(
      METHODS.GET,
      API.SENSOR_DATA_SESSIONS.GET_SENSOR_DATA_SESSION_DOTS(String(payload.id)),
    )({ params: { files: payload.files, station: payload.station } });
  },
};
